import "./subHeader.css";

import styled from "styled-components";
import { NavLink } from "react-router-dom";
import pr센터 from "../pages/img/subheader/subheader3.jpg";
import i18next from "../config/lang/i18next";

const subHeader = () => (
  <div className="container_header">
    <style>
      {`

 .sub_header{
     box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.4);
  }

  @media (max-width: 700px) {
    .none, .selected {
      width: 50%;
      
    }
  }
  
`}
    </style>
    <div className="sub_header subheader3" style={{ backgroundImage: `url(${pr센터})`, backgroundSize:"cover", backgroundPosition:"center center" }}>
      <div className="sub_header_txt">
        <h2>PR Center</h2>
        <hr></hr>
        <h3>What is New at GM Medical</h3>
      </div>
      <div className="ul_wrapper fixed">
        <ul className="menu_container clearfix">
          <NavLink
            exact="true"
            className={(navData) => (navData.isActive ? "selected" : "none")}
            to="/news"
          >
            <li>{i18next.t("navbar.3-1")}</li>
          </NavLink>
      
        </ul>
      </div>
    </div>
  </div>
);

export default subHeader;
